export const createDeliveryDateApi = (fetchApi) => {
  function getDeliveryTimes(data, oneTimeCode) {
    return fetchApi(`/DeliveryTimes?oneTimeCode=${oneTimeCode}`, "POST", data);
  }

  return {
    getDeliveryTimes,
  };
};
